import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = { class: "res-cab" }
const _hoisted_5 = { class: "res-titulo" }
const _hoisted_6 = { class: "res-periodo" }
const _hoisted_7 = { class: "filtro-campus" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "loading"
}
const _hoisted_10 = {
  key: 0,
  class: "consolidado"
}
const _hoisted_11 = { class: "cons-cab" }
const _hoisted_12 = { class: "cons-nota-bloque" }
const _hoisted_13 = { class: "cons-nota" }
const _hoisted_14 = { class: "cons-escala" }
const _hoisted_15 = {
  key: 0,
  class: "cons-equivalente"
}
const _hoisted_16 = { class: "cons-detalle" }
const _hoisted_17 = {
  key: 0,
  class: "cons-aviso"
}
const _hoisted_18 = {
  key: 1,
  class: "tabla-scroll"
}
const _hoisted_19 = { class: "tabla" }
const _hoisted_20 = { class: "tabla-scroll" }
const _hoisted_21 = { class: "tabla" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = {
  key: 2,
  class: "texto-vacio"
}
const _hoisted_24 = {
  key: 2,
  class: "texto-vacio"
}
const _hoisted_25 = { class: "tabla-scroll" }
const _hoisted_26 = {
  key: 0,
  class: "loading"
}
const _hoisted_27 = {
  key: 1,
  class: "tabla"
}
const _hoisted_28 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_29 = { class: "badge" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "texto-vacio"
}
const _hoisted_32 = {
  key: 0,
  class: "botones",
  style: {"margin":"1rem 0 1.5rem"}
}
const _hoisted_33 = {
  key: 1,
  class: "marco"
}
const _hoisted_34 = { class: "formulario-opcion" }
const _hoisted_35 = { class: "fila-doble" }
const _hoisted_36 = { class: "formulario-opcion" }
const _hoisted_37 = { class: "periodo-editor" }
const _hoisted_38 = { class: "formulario-opcion" }
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "formulario-opcion" }
const _hoisted_41 = { class: "campus-grid" }
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "campus-nombre" }
const _hoisted_44 = { class: "campus-programas" }
const _hoisted_45 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_46 = { class: "formulario-opcion" }
const _hoisted_47 = { class: "formulario-opcion" }
const _hoisted_48 = { class: "botones" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 2,
  class: "marco resultados"
}
const _hoisted_51 = { class: "res-cab" }
const _hoisted_52 = { class: "res-titulo-sm" }
const _hoisted_53 = { class: "filtro-campus" }
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  key: 0,
  class: "loading"
}
const _hoisted_56 = {
  key: 0,
  class: "consolidado"
}
const _hoisted_57 = { class: "cons-cab" }
const _hoisted_58 = { class: "cons-nota-bloque" }
const _hoisted_59 = { class: "cons-nota" }
const _hoisted_60 = { class: "cons-escala" }
const _hoisted_61 = {
  key: 0,
  class: "cons-equivalente"
}
const _hoisted_62 = { class: "cons-detalle" }
const _hoisted_63 = {
  key: 0,
  class: "cons-aviso"
}
const _hoisted_64 = {
  key: 1,
  class: "tabla-scroll"
}
const _hoisted_65 = { class: "tabla" }
const _hoisted_66 = { class: "tabla-scroll" }
const _hoisted_67 = { class: "tabla" }
const _hoisted_68 = ["disabled", "onClick"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import { useGestionVersiones } from '@/store/GestionVersiones'
import {
  listarProcesosInstitucionalesService,
  getCampusDisponiblesService,
  crearProcesoInstitucionalService,
  getResultadosInstitucionalesService,
  getProcesoInstitucionalService,
  type ProcesoInstitucional,
  type CampusDisponible,
  type ResultadosInstitucionales
} from '@/services/ProcesoInstitucionalService'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcesoInstitucionalView',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const versionesStore = useGestionVersiones()

const modoResultadoDirecto = computed(() => !!route.query.id)

const procesos = ref<ProcesoInstitucional[]>([])
const campusDisponibles = ref<CampusDisponible[]>([])
const versiones = ref<Array<{ id_version: number; nombre: string }>>([])
const cargando = ref(false)
const guardando = ref(false)
const mostrarForm = ref(false)
const cargandoDirecto = ref(false)

const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'positivo') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const hoy = new Date()
const periodoAnio = ref(hoy.getFullYear())
const periodoSemestre = ref(hoy.getMonth() < 6 ? '1' : '2')

const form = ref({
  nombre: '',
  id_version: 0,
  criterio_consolidacion: 'ponderado' as 'simple' | 'ponderado',
  observaciones: '',
  campus: [] as number[]
})

const puedeGuardar = computed(
  () => !!form.value.nombre.trim() && form.value.id_version > 0 && form.value.campus.length > 0
)

function abrirFormulario() {
  form.value = { nombre: '', id_version: 0, criterio_consolidacion: 'ponderado', observaciones: '', campus: [] }
  mostrarForm.value = true
}

async function cargar() {
  cargando.value = true
  try {
    procesos.value = await listarProcesosInstitucionalesService()
    campusDisponibles.value = await getCampusDisponiblesService()
  } finally {
    cargando.value = false
  }
}

async function guardar() {
  if (!puedeGuardar.value) return
  guardando.value = true
  try {
    const resultado = await crearProcesoInstitucionalService({
      nombre: form.value.nombre.trim(),
      periodo: `${periodoAnio.value}-${periodoSemestre.value}`,
      id_version: form.value.id_version,
      criterio_consolidacion: form.value.criterio_consolidacion,
      observaciones: form.value.observaciones || null,
      campus: form.value.campus
    })
    if (!resultado.ok) {
      mostrarMensaje(resultado.error ?? 'No se pudo crear el proceso', 'error')
      return
    }
    mostrarMensaje(`Proceso creado con ${form.value.campus.length} campus`, 'positivo')
    mostrarForm.value = false
    await cargar()
  } finally {
    guardando.value = false
  }
}

// ── Resultados ────────────────────────────────────────────────────────
const procesoActivo = ref<ProcesoInstitucional | null>(null)
const resultados = ref<ResultadosInstitucionales | null>(null)
const campusFiltrado = ref<number | null>(null)
const cargandoResultados = ref(false)

const estadosPorEjecucion = computed<Record<number, string>>(() => {
  const mapa: Record<number, string> = {}
  for (const e of procesoActivo.value?.ejecuciones ?? []) {
    mapa[e.id_ejecucion] = e.estado
  }
  return mapa
})

function irAResultadosCampus(idEjecucion: number) {
  router.push({ name: 'ResultadosAutoevaluacion', params: { id_ejecucion: idEjecucion } })
}

function estadoClass(estado?: string | null) {
  const map: Record<string, string> = {
    preparacion: 'estado-modificar',
    ejecucion:   'estado-completado',
    evaluacion:  'estado-aprobado',
    informe:     'estado-aprobado',
    finalizado:  'estado-descontinuado'
  }
  return map[estado ?? ''] ?? 'estado-modificar'
}

async function verResultados(proceso: ProcesoInstitucional) {
  procesoActivo.value = proceso
  campusFiltrado.value = null
  await cargarResultados()
}

async function cargarResultados() {
  if (!procesoActivo.value) return
  cargandoResultados.value = true
  try {
    resultados.value = await getResultadosInstitucionalesService(
      procesoActivo.value.id_proceso_institucional,
      campusFiltrado.value
    )
  } finally {
    cargandoResultados.value = false
  }
}

function cerrarResultados() {
  procesoActivo.value = null
  resultados.value = null
}

function volver() {
  router.push({ name: 'ProcesoAutoevaluacion', query: { modo: 'admin', tab: 'institucional-general' } })
}

onMounted(async () => {
  await versionesStore.getVersiones()
  versiones.value = (versionesStore.versiones as any[]).map(v => ({
    id_version: v.id_version,
    nombre: v.nombre
  }))

  const idParam = route.query.id
  if (idParam) {
    cargandoDirecto.value = true
    const id = Number(idParam)
    const proceso = await getProcesoInstitucionalService(id)
    cargandoDirecto.value = false
    if (proceso) {
      await verResultados(proceso)
    }
  } else {
    await cargar()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h1", null, "Autoevaluación Institucional", -1)),
      (modoResultadoDirecto.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn salir",
            onClick: volver
          }, "Volver"))
        : _createCommentVNode("", true)
    ]),
    _cache[39] || (_cache[39] = _createElementVNode("p", { class: "subtitulo" }, " Consolidado de resultados de múltiples campus bajo un mismo proceso institucional. ", -1)),
    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (modoResultadoDirecto.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (cargandoDirecto.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Cargando proceso..."))
            : (procesoActivo.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_5, _toDisplayString(procesoActivo.value.nombre), 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(procesoActivo.value.periodo), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", null, "Ver campus:", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((campusFiltrado).value = $event)),
                        class: "form-control",
                        onChange: cargarResultados
                      }, [
                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: null }, "Todos (consolidado)", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesoActivo.value.ejecuciones ?? [], (e) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: e.id_ejecucion,
                            value: e.id_campus
                          }, _toDisplayString(e.campus?.nombre ?? 'Sin campus'), 9, _hoisted_8))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, campusFiltrado.value]
                      ])
                    ])
                  ]),
                  (cargandoResultados.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Calculando resultados..."))
                    : (resultados.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (resultados.value.consolidado)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "cons-etiqueta" }, "Resultado institucional", -1)),
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(resultados.value.consolidado.global?.toFixed(2) ?? '—'), 1),
                                    _createElementVNode("span", _hoisted_14, "sobre " + _toDisplayString(resultados.value.consolidado.escala_max), 1)
                                  ]),
                                  (resultados.value.consolidado.equivalencias?.en_diez != null && resultados.value.consolidado.escala_max === 5)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, " equivale a " + _toDisplayString(resultados.value.consolidado.equivalencias.en_diez?.toFixed(2)) + " en escala 1–10 ", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("p", _hoisted_16, [
                                  _cache[15] || (_cache[15] = _createTextVNode(" Consolidado ")),
                                  _createElementVNode("strong", null, _toDisplayString(resultados.value.criterio_consolidacion), 1),
                                  _createTextVNode(" sobre " + _toDisplayString(resultados.value.consolidado.campus_considerados) + " campus. ", 1)
                                ]),
                                (resultados.value.consolidado.campus_sin_calificar.length)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Sin calificar todavía: " + _toDisplayString(resultados.value.consolidado.campus_sin_calificar.map(c => c.campus ?? 'sin nombre').join(', ')) + ". No cuentan como cero: quedan fuera del cálculo. ", 1))
                                  : _createCommentVNode("", true),
                                (resultados.value.consolidado.factores.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createElementVNode("table", _hoisted_19, [
                                        _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                                          _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "Factor"),
                                            _createElementVNode("th", null, "Nota consolidada"),
                                            _createElementVNode("th", null, "Campus con nota")
                                          ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultados.value.consolidado.factores, (f, i) => {
                                            return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                              _createElementVNode("td", null, _toDisplayString(f.ordinal) + " " + _toDisplayString(f.nombre), 1),
                                              _createElementVNode("td", null, _toDisplayString(f.calificacion?.toFixed(2) ?? '—'), 1),
                                              _createElementVNode("td", null, _toDisplayString(f.campus_con_nota), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "sub-titulo" }, "Por campus", -1)),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("table", _hoisted_21, [
                              _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "Campus"),
                                  _createElementVNode("th", null, "Estado"),
                                  _createElementVNode("th", null, "Peso"),
                                  _createElementVNode("th", null, "Global"),
                                  _createElementVNode("th", null, "Nivel"),
                                  _createElementVNode("th")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultados.value.campus, (c) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: c.id_ejecucion
                                  }, [
                                    _createElementVNode("td", null, _toDisplayString(c.campus ?? 'Sin campus'), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(['estado', estadoClass(estadosPorEjecucion.value[c.id_ejecucion])])
                                      }, _toDisplayString(estadosPorEjecucion.value[c.id_ejecucion] ?? '—'), 3)
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(c.peso), 1),
                                    _createElementVNode("td", null, _toDisplayString(c.resultados?.global?.valoracion?.toFixed(2) ?? '—'), 1),
                                    _createElementVNode("td", null, _toDisplayString(c.resultados?.global?.grado ?? 'Sin calificar'), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("button", {
                                        class: "btn guardar btn-tabla",
                                        disabled: estadosPorEjecucion.value[c.id_ejecucion] !== 'informe',
                                        onClick: ($event: any) => (irAResultadosCampus(c.id_ejecucion))
                                      }, "Resultados", 8, _hoisted_22)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("p", _hoisted_23, "Los resultados no están disponibles aún."))
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_24, "No se encontró el proceso solicitado."))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_25, [
            (cargando.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Cargando procesos institucionales..."))
              : (procesos.value.length)
                ? (_openBlock(), _createElementBlock("table", _hoisted_27, [
                    _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Proceso"),
                        _createElementVNode("th", null, "Período"),
                        _createElementVNode("th", null, "Versión"),
                        _createElementVNode("th", null, "Campus"),
                        _createElementVNode("th", null, "Consolidación"),
                        _createElementVNode("th", null, "Acción")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesos.value, (p) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: p.id_proceso_institucional
                        }, [
                          _createElementVNode("td", null, _toDisplayString(p.nombre), 1),
                          _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                          _createElementVNode("td", null, _toDisplayString(p.version?.nombre ?? '—'), 1),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.ejecuciones ?? [], (e) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "chip-campus",
                                key: e.id_ejecucion
                              }, _toDisplayString(e.campus?.nombre ?? 'Sin campus'), 1))
                            }), 128)),
                            (!(p.ejecuciones ?? []).length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Sin campus"))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_29, _toDisplayString(p.criterio_consolidacion), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn guardar btn-tabla",
                              onClick: ($event: any) => (verResultados(p))
                            }, "Ver resultados", 8, _hoisted_30)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (!cargando.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, "Todavía no hay procesos institucionales."))
                  : _createCommentVNode("", true)
          ]),
          (!mostrarForm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("button", {
                  class: "btn guardar",
                  onClick: abrirFormulario
                }, "Nuevo Proceso Institucional")
              ]))
            : _createCommentVNode("", true),
          (mostrarForm.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "form-titulo" }, "Nuevo Proceso Institucional", -1)),
                _createElementVNode("div", _hoisted_34, [
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, [
                    _createTextVNode("Nombre "),
                    _createElementVNode("b", { class: "req" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.nombre) = $event)),
                    class: "form-control",
                    placeholder: "Autoevaluación Institucional 2026"
                  }, null, 512), [
                    [_vModelText, form.value.nombre]
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, [
                      _createTextVNode("Período "),
                      _createElementVNode("b", { class: "req" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((periodoAnio).value = $event)),
                        class: "periodo-anio",
                        min: "2000",
                        step: "1"
                      }, null, 512), [
                        [
                          _vModelText,
                          periodoAnio.value,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "periodo-sep" }, "-", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((periodoSemestre).value = $event)),
                        class: "periodo-semestre"
                      }, _cache[21] || (_cache[21] = [
                        _createElementVNode("option", { value: "1" }, "1", -1),
                        _createElementVNode("option", { value: "2" }, "2", -1)
                      ]), 512), [
                        [_vModelSelect, periodoSemestre.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", null, [
                      _createTextVNode("Versión del modelo "),
                      _createElementVNode("b", { class: "req" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.id_version) = $event)),
                      class: "form-control"
                    }, [
                      _cache[24] || (_cache[24] = _createElementVNode("option", {
                        value: 0,
                        disabled: ""
                      }, "Selecciona una versión", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versiones.value, (v) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: v.id_version,
                          value: v.id_version
                        }, _toDisplayString(v.nombre), 9, _hoisted_39))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, form.value.id_version]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", null, [
                    _createTextVNode("Campus participantes "),
                    _createElementVNode("b", { class: "req" }, "*")
                  ], -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "ayuda" }, " Cada campus marcado recibe su propia ejecución del modelo. ", -1)),
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campusDisponibles.value, (c) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: c.id_campus,
                        class: "campus-item"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          value: c.id_campus,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.campus) = $event))
                        }, null, 8, _hoisted_42), [
                          [_vModelCheckbox, form.value.campus]
                        ]),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(c.nombre), 1),
                        _createElementVNode("small", _hoisted_44, _toDisplayString(c.programas) + " programa" + _toDisplayString(c.programas === 1 ? '' : 's'), 1)
                      ]))
                    }), 128))
                  ]),
                  (!campusDisponibles.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_45, " No hay campus registrados. "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[29] || (_cache[29] = _createElementVNode("span", null, "Criterio de consolidación", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.criterio_consolidacion) = $event)),
                    class: "form-control"
                  }, _cache[28] || (_cache[28] = [
                    _createElementVNode("option", { value: "ponderado" }, "Ponderado por número de programas", -1),
                    _createElementVNode("option", { value: "simple" }, "Promedio simple (cada campus pesa igual)", -1)
                  ]), 512), [
                    [_vModelSelect, form.value.criterio_consolidacion]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _cache[30] || (_cache[30] = _createElementVNode("span", null, [
                    _createTextVNode("Observaciones "),
                    _createElementVNode("span", { class: "opcional" }, "(opcional)")
                  ], -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.observaciones) = $event)),
                    class: "form-control",
                    rows: "2"
                  }, null, 512), [
                    [_vModelText, form.value.observaciones]
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("button", {
                    class: "btn salir",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (mostrarForm.value = false))
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    disabled: !puedeGuardar.value || guardando.value,
                    onClick: guardar
                  }, _toDisplayString(guardando.value ? 'Creando...' : 'Crear proceso'), 9, _hoisted_49)
                ])
              ]))
            : _createCommentVNode("", true),
          (procesoActivo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("h3", _hoisted_52, _toDisplayString(procesoActivo.value.nombre) + " · " + _toDisplayString(procesoActivo.value.periodo), 1),
                  _createElementVNode("button", {
                    class: "btn salir btn-tabla",
                    onClick: cerrarResultados
                  }, "Cerrar")
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", null, "Ver campus:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((campusFiltrado).value = $event)),
                    class: "form-control filtro-select",
                    onChange: cargarResultados
                  }, [
                    _cache[32] || (_cache[32] = _createElementVNode("option", { value: null }, "Todos los campus (consolidado)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesoActivo.value.ejecuciones ?? [], (e) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: e.id_ejecucion,
                        value: e.id_campus
                      }, _toDisplayString(e.campus?.nombre ?? 'Sin campus'), 9, _hoisted_54))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, campusFiltrado.value]
                  ])
                ]),
                (cargandoResultados.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, "Calculando resultados..."))
                  : (resultados.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (resultados.value.consolidado)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _cache[34] || (_cache[34] = _createElementVNode("span", { class: "cons-etiqueta" }, "Resultado institucional", -1)),
                                  _createElementVNode("span", _hoisted_59, _toDisplayString(resultados.value.consolidado.global?.toFixed(2) ?? '—'), 1),
                                  _createElementVNode("span", _hoisted_60, "sobre " + _toDisplayString(resultados.value.consolidado.escala_max), 1)
                                ]),
                                (resultados.value.consolidado.equivalencias?.en_diez != null && resultados.value.consolidado.escala_max === 5)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, " equivale a " + _toDisplayString(resultados.value.consolidado.equivalencias.en_diez?.toFixed(2)) + " en escala 1–10 ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("p", _hoisted_62, [
                                _cache[35] || (_cache[35] = _createTextVNode(" Consolidado ")),
                                _createElementVNode("strong", null, _toDisplayString(resultados.value.criterio_consolidacion), 1),
                                _createTextVNode(" sobre " + _toDisplayString(resultados.value.consolidado.campus_considerados) + " campus. ", 1)
                              ]),
                              (resultados.value.consolidado.campus_sin_calificar.length)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_63, " Sin calificar todavía: " + _toDisplayString(resultados.value.consolidado.campus_sin_calificar.map(c => c.campus ?? 'sin nombre').join(', ')) + ". ", 1))
                                : _createCommentVNode("", true),
                              (resultados.value.consolidado.factores.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createElementVNode("table", _hoisted_65, [
                                      _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, "Factor"),
                                          _createElementVNode("th", null, "Nota consolidada"),
                                          _createElementVNode("th", null, "Campus con nota")
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultados.value.consolidado.factores, (f, i) => {
                                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                            _createElementVNode("td", null, _toDisplayString(f.ordinal) + " " + _toDisplayString(f.nombre), 1),
                                            _createElementVNode("td", null, _toDisplayString(f.calificacion?.toFixed(2) ?? '—'), 1),
                                            _createElementVNode("td", null, _toDisplayString(f.campus_con_nota), 1)
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _cache[38] || (_cache[38] = _createElementVNode("h4", { class: "sub-titulo" }, "Por campus", -1)),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("table", _hoisted_67, [
                            _cache[37] || (_cache[37] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Campus"),
                                _createElementVNode("th", null, "Estado"),
                                _createElementVNode("th", null, "Peso"),
                                _createElementVNode("th", null, "Global"),
                                _createElementVNode("th", null, "Nivel"),
                                _createElementVNode("th")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultados.value.campus, (c) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: c.id_ejecucion
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(c.campus ?? 'Sin campus'), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['estado', estadoClass(estadosPorEjecucion.value[c.id_ejecucion])])
                                    }, _toDisplayString(estadosPorEjecucion.value[c.id_ejecucion] ?? '—'), 3)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(c.peso), 1),
                                  _createElementVNode("td", null, _toDisplayString(c.resultados?.global?.valoracion?.toFixed(2) ?? '—'), 1),
                                  _createElementVNode("td", null, _toDisplayString(c.resultados?.global?.grado ?? 'Sin calificar'), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("button", {
                                      class: "btn guardar btn-tabla",
                                      disabled: estadosPorEjecucion.value[c.id_ejecucion] !== 'informe',
                                      onClick: ($event: any) => (irAResultadosCampus(c.id_ejecucion))
                                    }, "Resultados", 8, _hoisted_68)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[10] || (_cache[10] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})